<template>
	<div class="Scene" id="Scene">
		<div class="Scene_wrapper" ref="wrapper">
      
		</div>

		<div class="Scene_mask"></div>

		<!-- <div class="debug">
			<button @click="openMessage">Indice dialogue</button>
			<button @click="openIndice('longuevue')">Indice longue vue</button>
			<button @click="openIndice('boussole')">Indice indice boussolle</button>
			<button @click="openInteraction('word')">Open word</button>
		</div> -->
	</div>
</template>

<script>
	const THREE = require('three');
	global.THREE = THREE;

	require('three/examples/js/controls/OrbitControls.js');

	import { mapState, mapActions } from 'vuex';
	import Stats from "stats.js";
	import dat from "dat.gui";
	import { Lensflare, LensflareElement }  from "@/components/Scene/Lensflare.js";
	import Camera from "@/components/Scene/Camera.js";
	import Controls from "@/components/Scene/Controls.js";
	import Room from "@/components/Scene/Room.js";
	import Post from "@/components/Scene/Post.js";
	import blendFragmentShader from "@/components/Scene/blend.fs.js";
	import edgeFragmentShader from "@/components/Scene/edge.fs.js";
	import luminosityFragmentShader from "@/components/Scene/luminosity.fs.js";
	import fxaaFragmentShader from "@/components/Scene/fxaa.fs.js";
	import skyVertexShader from "@/components/Scene/sky.vs.js";
	import skyFragmentShader from "@/components/Scene/sky.fs.js";
	import colorEdgesFragmentShader from "@/components/Scene/colorEdges.fs.js";
	import colorEdgesVertexShader from "@/components/Scene/colorEdges.vs.js";
	import smaaFragmentShader from "@/components/Scene/smaa.fs.js";
	import smaaVertexShader from "@/components/Scene/smaa.vs.js";
	import weightsFragmentShader from "@/components/Scene/weights.fs.js";
	import weightsVertexShader from "@/components/Scene/weights.vs.js";
	import searchImageDataURL from "@/components/Scene/smaa.searchDataURL.js";
	import areaImageDataURL from "@/components/Scene/smaa.areaDataURL.js";
	import { TweenLite, Power2 } from "gsap/all";



	export default {
		props: [ 'renderable' ],
		data() {
			return {
				camera: null,
				scene: null,
				renderer: null,
				isLoaded: false,
				dpr: window.devicePixelRatio || 1,
				els: [],
				i: 0
			}
		},
		watch: {
			'camera.position': {
				handler(after, before) {
					if(!this.controls) return
					var rad = this.controls.getAzimuthalAngle();
					var deg = -rad * 180 / Math.PI
					if(this.controls)
						this.setAngle(deg)
				},
				immediate: true,
				deep: true
			},
			renderable()
			{
				if(!this.clock) return

				if(this.renderable)
					this.clock.start()
				else
					this.clock.stop()
			}
		},
		methods: {
			...mapActions([
				'setAngle'
			]),
			openIndice(slug)
			{
				this.$emit("openIndice", slug);
			},
			openInteraction(slug)
			{
				this.$emit("openInteraction", slug);
			},
			openMessage(message)
			{
				this.$emit("openMessage", message);
			},
			loadCompleted()
			{
				this.isLoaded = true;
				console.log( 'loadCompleted' );
				this.$emit('loadCompleted')				

				// this.startIntro()
			},
			init()
			{
				this.renderer = new THREE.WebGLRenderer( { antialias: this.$tools.isMobile() ? false : true } );
				this.renderer.setPixelRatio(this.dpr);
				this.renderer.setSize(this.$el.offsetWidth, this.$el.offsetHeight);

				this.renderer.gammaFactor = 2.5;
				this.renderer.gammaOutput = true;
				
				this.$refs.wrapper.appendChild(this.renderer.domElement);

				this.rectWrapper = this.$refs.wrapper.getBoundingClientRect();

				this.scene = new THREE.Scene();
				this.raycaster = new THREE.Raycaster();

				window.scene = this.scene;
				window.THREE = THREE;

				this.intersectedObject = null;
				this.lastTime = 0;
				this.deltaTime = 0;
				this.timeSinceIntersection = 0;
				this.maxTimeSinceIntersection = 4000; // CHANGE MAX TIME HERE
				this.checkIntersectionTime = true; // SET TO FALSE AND CHANGE TO TRUE ONCE CLICKED FOR THE FIRST TIME
				
				this.mouse = { x: 0, y: 0 };
				this.resolution = {
					value: new THREE.Vector2(this.$el.offsetWidth, this.$el.offsetHeight)
				};
				this.texelSize = { value: new THREE.Vector2(1.0 / this.resolution.value.x, 1.0 / this.resolution.value.y) }; 

				// CAMERA

				this.camera = new Camera(60, this.$el.offsetWidth / this.$el.offsetHeight, 1, 7000, {
					element: this.$refs.wrapper,
				});
				
				// CONTROLS

				// this.target = 
				this.controls = new THREE.OrbitControls(this.camera, this.$refs.wrapper);
				this.controls.enableZoom = false;
				this.controls.enablePan = false;
				this.controls.enabled = false;
				this.controls.target = new THREE.Vector3(900, -350, 100);
				// this.camera.position.set(317, 45, -55);
				this.camera.position.set(-150, 200, -200);
				// this.camera.lookAt(new THREE.Vector3(950, 150, 400));
				// this.controls.rotation.set(90 * Math.PI / 180, 0, 0);
				this.controls.update()
 
        this.createLights();
        this.createSky();
        this.createRoom();
				this.initPost();
			
				document.addEventListener('mousemove', this.onMouseMove);
				document.addEventListener('touchstart', this.onTouchStart);
				document.addEventListener('touchend', this.onTouchEnd);
				document.addEventListener('click', this.onDocumentClick);

				this.renderSMAA = true;

				// setTimeout( () => {
					// this.initGUI();
				// }, 1000 )

				// this.initStats();
				
				this.animate();
			},
			createLights()
			{
				// var light = new THREE.AmbientLight( 0xf7cedf, 1 );
				// this.scene.add( light );

				// var l = new THREE.AmbientLight( 0xf7cedf, .4 );
        // l.position.set( 10, 10, 10 );
				// this.scene.add(l);

				this.createFlare( 1930, -20, 174 );
			},
			createFlare( x, y, z ) {

				var textureLoader = new THREE.TextureLoader();

				var textureFlare0 = textureLoader.load( "assets/images/lensflare0.png" );
				var textureFlare3 = textureLoader.load( "assets/images/lensflare3.png" );

				this.lensflare = new THREE.Lensflare();
				this.lensflare.addElement( new THREE.LensflareElement( textureFlare0, 700, 0 ) );
				this.lensflare.addElement( new THREE.LensflareElement( textureFlare3, 60, 0.6 ) );
				this.lensflare.addElement( new THREE.LensflareElement( textureFlare3, 70, 0.7 ) );
				this.lensflare.addElement( new THREE.LensflareElement( textureFlare3, 120, 0.9 ) );
				this.lensflare.addElement( new THREE.LensflareElement( textureFlare3, 70, 1 ) );
				this.lensflare.position.set( x, y, z );
				this.scene.add( this.lensflare );

			},
			createSky()
			{
				var uniforms = {
            topColor:    { value: new THREE.Color( 0x71abe0 ) },
            bottomColor: { value: new THREE.Color( 0xf7cedf ) },
            offset:      { value: 0 },
            exponent:    { value: 1 }
        };
        uniforms.topColor.value.setHSL( 0.6, 1, 0.6 );

        var skyGeo = new THREE.SphereGeometry( 4000, 32, 32 );
        var skyMat = new THREE.ShaderMaterial( { vertexShader: skyVertexShader, fragmentShader: skyFragmentShader, uniforms: uniforms, side: THREE.BackSide } );

				this.sky = new THREE.Mesh( skyGeo, skyMat );
				this.sky.name = "sky"
				this.sky.position.set(0, 0, 300);
				this.scene.add( this.sky );
			},
			createRoom()
			{
				this.room = new Room({
					onClickNote: () => {
						this.openIndice('boussole');
					},
					onClickLongueVue: () => {
						this.openIndice('longuevue');
					},
					onClickCale: () => {
						this.openMessage( { title: "Paulo le pirate :", content: "Eh oh moussaillon ! J'ai entendu l'un des matelots dire que le dernier chiffre du code était un 4.", thumb: "pirate.svg" } );
					},
					onClickPerroquet: () => {
						this.openInteraction('word');
					},
					onLoad: this.loadCompleted,
				});

				this.scene.add(this.room);
			},
			initPost()
			{
				this.post = new Post({
					width: this.$el.offsetWidth,
					height: this.$el.offsetHeight,
					dpr: this.dpr
				});

				this.rtFocus = new THREE.WebGLRenderTarget(1, 1, {
					format: THREE.RGBAFormat,
				});
				this.rtFocus.setSize(this.$el.offsetWidth, this.$el.offsetHeight);

				this.outlinePass = this.post.addPass({
					fragmentShader: edgeFragmentShader,
					uniforms: {
						uResolution: this.resolution,
						tFocusMap: { value: this.rtFocus.texture },
						uOverlayColor: { value: new THREE.Color(0xFFFFFF)},
						uOverlayOpacity: { value: 0.2 },
						uOutlineColor: { value: new THREE.Color(0xFFFFFF)},
						uOutlineOpacity: { value: 0.1 },
					},
					enabled: false,
				});

				this.rtColorEdges = new THREE.WebGLRenderTarget(1, 1);
				this.rtColorEdges.setSize(this.$el.offsetWidth, this.$el.offsetHeight);
					
				this.colorEdgesPass = this.post.addPass({
					target: this.rtColorEdges,
					vertexShader: colorEdgesVertexShader,
					fragmentShader: colorEdgesFragmentShader,
					uniforms: {
						texelSize: this.texelSize,
					},
					defines: {
						LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
						EDGE_THRESHOLD: "0.1",
					},
					enabled: false,
				});

				this.rtWeights = this.rtColorEdges.clone();
				this.rtWeights.texture.format = THREE.RGBAFormat;

				this.clock = new THREE.Clock();

				this.weightsPass = this.post.addPass({
					target: this.rtWeights,
					vertexShader: weightsVertexShader,
					fragmentShader: weightsFragmentShader,
					uniforms: {
						edgeMap: { value: this.rtColorEdges.texture },
						uResolution: this.resolution,
						texelSize: this.texelSize,
						searchTexture: { value: (() => {
							const searchTexture = new THREE.Texture();
							searchTexture.magFilter = THREE.NearestFilter;
							searchTexture.minFilter = THREE.NearestFilter;
							searchTexture.format = THREE.RGBAFormat;
							searchTexture.generateMipmaps = false;
							searchTexture.flipY = true;

							const searchImage = new Image();
							searchImage.addEventListener('load', () => {
								searchTexture.image = searchImage;
								searchTexture.needsUpdate = true;
							});
							searchImage.src = searchImageDataURL;

							return searchTexture;
						})() },
						areaTexture: { value: (() => {
							
							const areaTexture = new THREE.Texture(areaImage);
							areaTexture.minFilter = THREE.LinearFilter;
							areaTexture.format = THREE.RGBAFormat;
							areaTexture.generateMipmaps = false;
							areaTexture.flipY = false;

							const areaImage = new Image();
							areaImage.addEventListener('load', () => {
								areaTexture.image = areaImage;
								areaTexture.needsUpdate = true;
							});
							areaImage.src = areaImageDataURL;

							return areaTexture;
						})() },
					},
					defines: {
						// Configurable settings:
						MAX_SEARCH_STEPS_INT: "32",
						MAX_SEARCH_STEPS_FLOAT: "32.0",
						MAX_SEARCH_STEPS_DIAG_INT: "16",
						MAX_SEARCH_STEPS_DIAG_FLOAT: "16.0",
						CORNER_ROUNDING: "25",
						CORNER_ROUNDING_NORM: "0.25",

						// Non-configurable settings:
						AREATEX_MAX_DISTANCE: "16.0",
						AREATEX_MAX_DISTANCE_DIAG: "20.0",
						AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
						AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
						SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
						SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
					},
					enabled: false,
				});

				this.smaaPass = this.post.addPass({
					vertexShader: smaaVertexShader,
					fragmentShader: smaaFragmentShader,
					uniforms: {
						weightMap: { value: this.rtWeights.texture },
						texelSize: this.texelSize,
						uBrightness: { value: -.4 },
						uContrast: { value: .7 },
					},
					enabled: false,
				});

				this.renderTargets = [
					this.rtColorEdges,
					this.rtWeights,
					this.rtFocus,
				];
			},
			initStats()
			{
				this.stats = new Stats();
				this.$el.appendChild( this.stats.dom );
			},
			initGUI() {
				
				this.gui = new dat.GUI();

				this.gui.add(this.camera, 'fov', 25, 100).name('camera fov').onChange( () => {
					this.camera.updateProjectionMatrix();
				})

				this.gui.add(this.camera, 'zoom', 0, ).name('camera zoom').onChange( () => {
					this.camera.updateProjectionMatrix();
				})

				this.gui.add(this.camera.position, 'y', 0, 1000).step(0.1).name('camera y');

				const params = {
					flareX: this.lensflare.position.x,
					flareY: this.lensflare.position.y,
					flareZ: this.lensflare.position.z,
					skyTopColor: this.sky.material.uniforms.topColor.value.getHex(),
					skyBottomColor: this.sky.material.uniforms.bottomColor.value.getHex(),
					skyOffset: this.sky.material.uniforms.offset.value,
					overlayColor: this.outlinePass.material.uniforms.uOverlayColor.value.getHex(),
					overlayOpacity: this.outlinePass.material.uniforms.uOverlayOpacity.value,
					outlineColor: this.outlinePass.material.uniforms.uOutlineColor.value.getHex(),
					outlineOpacity: this.outlinePass.material.uniforms.uOutlineOpacity.value,
				};

				this.gui.add(params, 'flareX', -3000, 3000).step(0.01).onChange( () => {
					this.lensflare.position.x = params.flareX;
				});
				this.gui.add(params, 'flareY', -3000, 3000).step(0.01).onChange( () => {
					this.lensflare.position.y = params.flareY;
				});
				this.gui.add(params, 'flareZ', -3000, 3000).step(0.01).onChange( () => {
					this.lensflare.position.z = params.flareZ;
				});

				this.gui.addColor(params, 'skyTopColor', 0.01, 100).onChange( () => {
					this.sky.material.uniforms.topColor.value = new THREE.Color(params.skyTopColor);
				});
				this.gui.addColor(params, 'skyBottomColor', 0.01, 100).onChange( () => {
					this.sky.material.uniforms.bottomColor.value = new THREE.Color(params.skyBottomColor);
				});
				this.gui.add(params, 'skyOffset', 0, 500).step(0.01).onChange( () => {
					this.sky.material.uniforms.offset.value = params.skyOffset;
				});

				this.gui.addColor(params, 'overlayColor').onChange( () => {
					this.outlinePass.material.uniforms.uOverlayColor.value = new THREE.Color(params.overlayColor);
				});
				this.gui.add(params, 'overlayOpacity', 0, 1).step(0.01).onChange( () => {
					this.outlinePass.material.uniforms.uOverlayOpacity.value = params.overlayOpacity;
				});
				this.gui.addColor(params, 'outlineColor', 0.01, 100).onChange( () => {
					this.outlinePass.material.uniforms.uOutlineColor.value = new THREE.Color(params.outlineColor);
				});
				this.gui.add(params, 'outlineOpacity', 0, 1).step(0.01).onChange( () => {
					this.outlinePass.material.uniforms.uOutlineOpacity.value = params.outlineOpacity;
				});
				this.gui.add(this, 'renderSMAA').name('smaa');
				this.gui.add(this.smaaPass.material.uniforms.uBrightness, 'value', -2, 2).step(0.01).name('brightness').onChange(() => {
					this.renderSMAA = true;
				});
				this.gui.add(this.smaaPass.material.uniforms.uContrast, 'value', -2, 2).step(0.01).name('contrast').onChange(() => {
					this.renderSMAA = true;
				});
			},
			startIntro()
			{
				// return;
				this.transition = {
					positionX: this.camera.position.x,
					positionY: this.camera.position.y,
					positionZ: this.camera.position.z,
					lookX: 900,
					lookY: -350,
					lookZ: 100
				}

				this.sunrise = {
					brightness: -.4,
					contrast: .7,
					flareY: -20
				}

				// TweenLite.to(this.transition, 2, { easing: Power4.easeInOut, targetX:950, targetY:150, targetZ:400 });
				TweenLite.to(this.transition, 7, {
					ease: Power2.easeInOut,
					lookX:950,
					lookY:150,
					lookZ:400,
					positionX:317,
					positionY:45,
					positionZ:-55,
					onUpdate:this.onSlerpUpdate, onComplete: () =>
				{
					console.log( 'Intro: completed' );
					// this.controls = new THREE.OrbitControls(this.camera, this.$refs.wrapper);
					// this.controls.enableZoom = false;
					// this.controls.enablePan = false;

					var vd = new THREE.Vector3();
					this.camera.getWorldDirection( vd );

					this.$parent.$refs.currentView.withTuto = true

					this.controls.target = new THREE.Vector3(317+vd.x, 45+vd.y, -55+vd.z);
					this.camera.position.set(317, 45, -55);
					this.controls.enabled = true;
					// // this.controls.rotation.set(90 * Math.PI / 180, 0, 0);
					this.controls.update();

					this.currentCursor = 'move'
					document.querySelector('.Scene canvas').style.cursor = 'move';

					this.isCompleted = true;
				} })

				TweenLite.to(this.sunrise, 10, {
					ease: Power2.easeInOut,
					brightness: 0,
					contrast: 1,
					flareY: 175,
					onUpdate: this.onSlerpUpdateSunrise });
			},
			onSlerpUpdate() 
			{
				this.camera.position.set( this.transition.positionX, this.transition.positionY, this.transition.positionZ )
				this.camera.lookAt(new THREE.Vector3(this.transition.lookX, this.transition.lookY, this.transition.lookZ));
			},
			onSlerpUpdateSunrise()
			{
				this.smaaPass.material.uniforms.uBrightness.value = this.sunrise.brightness
				this.smaaPass.material.uniforms.uContrast.value = this.sunrise.contrast
				this.lensflare.position.y = this.sunrise.flareY
			},
			animate(time = 0)
			{	
				this.raf = requestAnimationFrame(this.animate);
				
				if( (this.$tools.isMobile() || this.dpr >= 2) && this.i++ % 2 != 0 ) return
				
				if (!this.renderable){
					return
				}

				// this.stats.begin();

				this.deltaTime = time - this.lastTime;
				this.lastTime = time;

				this.camera.updateMatrixWorld(); // must be before room.update()

				// // if (!this.controls.dragging()) {
				this.checkIntersection();
				// // }
				var delta = 0.75 * this.clock.getDelta();
				this.room.update(delta);
				// this.controls.update(this.deltaTime);

				// this.room.preRender( this.renderer, this.scene );

				if (this.isCompleted && this.intersectedObject && this.intersectedObject.name != "sky") {
					console.log( this.intersectedObject.object.name );
					this.intersectedObject.onMouseEnter();
					this.sky.visible = false;
					this.room.hideExcept(this.intersectedObject.object);
					this.renderer.setRenderTarget(this.rtFocus);
					this.renderer.render(this.scene, this.camera);
					this.sky.visible = true;
					this.intersectedObject.onMouseLeave();
					this.renderer.setRenderTarget(null);
					this.room.displayAll();

					if( this.currentCursor != 'pointer' )
					{
						document.querySelector('.Scene canvas').style.cursor = 'pointer';
						this.currentCursor = 'pointer';
					}
				} else {
					this.room.displayAll();

					if( this.currentCursor != 'move' && this.isCompleted )
					{
						document.querySelector('.Scene canvas').style.cursor = 'move';
						this.currentCursor = 'move';
					}
				}

				this.outlinePass.enabled = this.intersectedObject ? true : false;

				if (this.renderSMAA) {
					this.colorEdgesPass.enabled = true;
					this.weightsPass.enabled = true;
					this.smaaPass.enabled = false;
					this.post.render(this.renderer, this.scene, this.camera);
					this.colorEdgesPass.enabled = false;
					this.weightsPass.enabled = false;
					this.outlinePass.enabled = this.intersectedObject ? true : false;
					this.smaaPass.enabled = true;
				} else {
					this.colorEdgesPass.enabled = false;
					this.weightsPass.enabled = false;
					this.smaaPass.enabled = false;
				}
				this.post.render(this.renderer, this.scene, this.camera);

				// this.stats.end();
		
				// this.renderer.render( this.scene, this.camera );
			},
			onMouseMove(event) {
				this.rectWrapper = this.$refs.wrapper.getBoundingClientRect();

				this.mouse.x = ((event.clientX - this.rectWrapper.left) / this.rectWrapper.width) * 2 - 1;
        this.mouse.y = - ((event.clientY - this.rectWrapper.top) / this.rectWrapper.height) * 2 + 1;
			},
			onTouchStart(event) {
				this.rectWrapper = this.$refs.wrapper.getBoundingClientRect();

				this.mouse.x = ((event.touches[0].clientX - this.rectWrapper.left) / this.rectWrapper.width) * 2 - 1;
				this.mouse.y = - ((event.touches[0].clientY - this.rectWrapper.top) / this.rectWrapper.height) * 2 + 1;

				this.checkIntersection();
			},
			onTouchEnd(event) {
				if (this.intersectedObject && this.renderable && !this.highlightedObject) {
					this.intersectedObject.onClick();
					this.intersectedObject = null;
				}
			},
			onDocumentClick() {
				if (this.intersectedObject && this.renderable && !this.highlightedObject) {
					this.intersectedObject.onClick();
					this.intersectedObject = null;
				}
			},
			checkIntersection() {
				this.raycaster.setFromCamera(this.mouse, this.camera);

				let intersected = false;

				for (let i = 0; i < this.room.interactiveObjects.length; i++) {
					const interactiveObject = this.room.interactiveObjects[i];

					if (interactiveObject.object.interactable) {
						let intersect = this.raycaster.intersectObjects(interactiveObject.meshes);
	
						if (intersect.length > 0) {
							intersected = true;
							if (this.intersectedObject && interactiveObject.name !== this.intersectedObject.name) {
								this.intersectedObject = null;
							}

							if (this.highlightedObject) {
								this.highlightedObject = null;
							}

							if (!this.intersectedObject) {
								this.intersectedObject = interactiveObject;
							}
						}
					}
				}	

				if (this.isLoaded && this.checkIntersectionTime) {
					if (!this.intersectedObject) {
						this.timeSinceIntersection += this.deltaTime;
					} else {
						this.timeSinceIntersection = 0;
					}

					if (this.timeSinceIntersection > this.maxTimeSinceIntersection) {
						this.highlightObject();
					}
				}

				if (this.intersectedObject && !intersected && !this.highlightedObject) {
					this.intersectedObject.onMouseLeave();
					this.intersectedObject = null;
				}
			},
			highlightObject() {
				const randomIndex = Math.floor(Math.random() * this.room.interactiveObjects.length);
				const interactiveObject = this.room.interactiveObjects[randomIndex];

				this.intersectedObject = interactiveObject;
				this.highlightedObject = interactiveObject;
			},
			onResize() {
				this.rectWrapper = this.$refs.wrapper.getBoundingClientRect();

				let width = this.$el.offsetWidth;
				let height = this.$el.offsetHeight;

				if (this.camera) {
					this.dpr = 1; //window.devicePixelRatio || 1;
					this.camera.aspect = width / height;
					this.camera.updateProjectionMatrix();
					this.renderer.setSize(width, height);
					this.post.render(this.renderer, this.scene, this.camera);
				}

				if (this.renderTargets && this.renderTargets.length > 0) {
					for (let i = 0; i < this.renderTargets.length; i++) {
						this.renderTargets[i].setSize(width, height);
					}
				}
			}
		},
		mounted()
		{
			setTimeout( () => {
				this.init();
				window.addEventListener('resize', this.onResize);
			}, 2000)
		},
		beforeDestroy()
		{
			window.removeEventListener('resize', this.onResize);
			document.removeEventListener('mousemove', this.onMouseMove);
			document.removeEventListener('touchstart', this.onTouchStart);
			document.removeEventListener('touchend', this.onTouchEnd);

			if (this.raf) {
				cancelAnimationFrame(this.raf);
			}

			for (let i = 0; i < this.renderTargets.length; i++) {
				this.renderTargets[i] = null;
			}

			this.controls.dispose();
			this.controls = null;

			this.scene.remove(this.room);
			this.room.dispose();
			this.room = null;

			this.post.dispose();
			this.post = null;

			this.colorEdgesPass = null;
			this.weightsPass = null;
			this.smaaPass = null;
			this.outlinePass = null;

			if (this.gui) {
				this.gui.destroy();
				this.gui = null;
			}

			this.intersectedObject = null;
			this.mouse = null;
			this.texelSize = null;
			this.resolution = null;
			this.camera = null;
			this.scene = null;
			this.renderer = null;
		}
	}
</script>

<style lang="stylus">
.debug

  position absolute 
  left 0px
  bottom 0px
  z-index 100

.Scene

	&_mask

		position fixed
		top 0px
		left -10%
		width 120%
		height 100%
		background url('/assets/images/mask.png')
		background-size 100% 100%
		pointer-events none
		opacity 0.4
		touch-action none
		background-position center

	&_texture

		position fixed
		top 0px
		left -10%
		width 120%
		height 100%
		background url('/assets/images/texture.jpg')
		background-size 100% 100%
		pointer-events none
		opacity 0.7

		touch-action none
		background-position center

#Scene

	height 100%
	width 100%
	overflow hidden
  top 0px
  left 0px
	position fixed
	background: rgb(144,183,249);
	background: linear-gradient(180deg, rgba(145,180,250,1) 0%, rgba(220,200,210,1) 30%, rgba(215,150,200,1) 70%);


</style>